import { graphql } from 'app/generated/gql'
import { useQuery } from 'urql'

import type { ContactField } from 'app/lib/workflows/dataContext'

const WORKFLOW_DATE_TRIGGER_FIELDS_QUERY = graphql(`
  query WorkflowDateTriggerFields($sourceType: String) {
    workflowDateTriggerFields(sourceType: $sourceType) {
      sourceType
      attribute
      storage
    }
  }
`)

// Humanize a camelCase field name: "lastTreatmentPlanDate" → "Last treatment plan date"
function humanize(attribute: string): string {
  const words = attribute.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()
  return words.charAt(0).toUpperCase() + words.slice(1)
}

/** Fetches available date trigger fields from the API for a given source type. */
export function useDateTriggerFields(sourceType: 'Contact' | 'Appointment'): ContactField[] {
  const [{ data }] = useQuery({
    query: WORKFLOW_DATE_TRIGGER_FIELDS_QUERY,
    variables: { sourceType },
  })

  if (!data?.workflowDateTriggerFields?.length) return []

  return data.workflowDateTriggerFields.map((f) => ({
    key: f.attribute,
    label: humanize(f.attribute),
    type: 'text' as const,
  }))
}
